<template>
  <div class="page page-add">
    <div class="page-container">
      <div class="page-title">推送消息详情</div>
      <div class="panel-info w800">
        <table class="table table-plain">
          <tbody>
            <tr>
              <th width="160">推送主题</th>
              <td>{{ record.body && record.body.first }}</td>
            </tr>
            <tr>
              <th>活动内容</th>
              <td>{{ record.body && record.body.keyword1 }}</td>
            </tr>
            <tr>
              <th>活动进展</th>
              <td>{{ record.body && record.body.keyword2 }}</td>
            </tr>
            <tr>
              <th>备注</th>
              <td>{{ record.body && record.body.remark }}</td>
            </tr>
            <tr>
              <th>跳转链接</th>
              <td>{{ record.body && record.body.url }}</td>
            </tr>
            <tr>
              <th>发送时间</th>
              <td>{{ record.publishTime }}</td>
            </tr>
            <tr>
              <th>发送用户</th>
              <td>
                <template v-if="record.users">
                  <a-tag color="red" v-for="item in record.users" :key="item.id">{{ item.realName || item.userName }}（{{ item.phone }}）</a-tag>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <a-affix :offset-bottom="10" :target="() => this.$refs.container">
          <div class="text-center v-mt-sm">
            <a-space>
              <a-button icon="left" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </a-affix>
      </div>
    </div>
  </div>
</template>

<script>
import { getWxMsg } from '@/api/system/wxmsg'

export default {
  data() {
    return {
      wxMsgId: undefined,
      record: {},
      files: [],
    }
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.wxMsgId = +id
        this.loadWxMsg()
      }
    },
    loadWxMsg() {
      getWxMsg(this.wxMsgId).then(({ data }) => {
        if (data.success) {
          let { content = '{}' } = data.result
          this.record = data.result
          this.record.body = JSON.parse(content)
        }
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
